import React from "react"
import clsx from "clsx"
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  useAccordionItemContext,
} from "@reach/accordion"
import { createDomMotionComponent } from "framer-motion"

import { Icon } from "components"

import Card from "./_Card"

const MotionAccordionPanel = createDomMotionComponent(AccordionPanel)

const motion = {
  ul: createDomMotionComponent("ul"),
}

const panelVariants = {
  open: {
    height: "auto",
    transition: {
      type: "easeOut",
      duration: 0.4,
      delayChildren: 0.2,
    },
  },
  closed: {
    height: 0,
    transition: {
      when: "afterChildren",
    },
  },
}

const contentVariants = {
  open: {
    opacity: 1,
    pointerEvents: "auto",
    y: 0,
    transition: {
      type: "easeOut",
      duration: 0.3,
    },
  },
  closed: {
    opacity: 0,
    pointerEvents: "none",
    y: 16,
    transition: {
      type: "easeOut",
      duration: 0.2,
    },
  },
}

function Inner({ cities, count, state }) {
  const { isExpanded } = useAccordionItemContext()
  if (state)
    return (
      <>
        <h3>
          <AccordionButton
            className={clsx(
              "flex w-full text-left lead-bold text-darkNavy focus:outline-none focus:text-violet",
              isExpanded ? "py-4 md:pt-8 md:pb-6" : "py-4 md:py-8"
            )}
          >
            <span
              className="flex w-auto pr-4 md:justify-end md:w-18"
              style={{ marginTop: "0.875em", fontSize: "0.5em" }}
            >
              <Icon
                className="text-violet"
                symbol={isExpanded ? "minus" : "plus"}
                size="1em"
              />
            </span>
            <span>
              {state}
              {count > 1 && ` (${count} facilities)`}
            </span>
          </AccordionButton>
        </h3>
        <MotionAccordionPanel
          className="focus:outline-none"
          hidden={false}
          aria-hidden={!isExpanded}
          initial="closed"
          animate={isExpanded ? "open" : "closed"}
          variants={panelVariants}
          layout
        >
          <motion.ul
            className="grid grid-cols-1 gap-4 pb-6 md:px-18 md:pb-8 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2"
            variants={contentVariants}
          >
            {cities
              ?.sort((a, b) => (a.city > b.city ? 1 : -1))
              ?.map((city, index) => (
                <Card {...city} key={`city-${index}`} />
              ))}
          </motion.ul>
        </MotionAccordionPanel>
      </>
    )
  else return null
}

function Item(props) {
  return (
    <AccordionItem as="li">
      <Inner {...props} />
    </AccordionItem>
  )
}

export default Item
